import { registerPlugin } from '@capacitor/core';

export interface FCMTokenPlugin {
  getToken(): Promise<{ token: string }>;
}

const FCMToken = registerPlugin<FCMTokenPlugin>('FCMToken');

export { FCMToken };
